import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/TableOfContents/sgds-table-of-contents";
import { register } from "../../utils/ce-registry";

register("sgds-table-of-contents", Component);

export default createComponent({
  react: React,
  tagName: "sgds-table-of-contents",
  elementClass: Component,
  events: {}
});
